import { useQuery } from '@tanstack/react-query';
import { recognitionStatusApi } from '../api/recognitionStatus';

export const useRecognitionStatuses = () => {
  return useQuery({
    queryKey: ['recognitionStatuses'],
    queryFn: () => recognitionStatusApi.list(),
    staleTime: 10 * 60 * 1000, // 10 minutes
    retry: 1,
  });
};
